import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { firestore as db } from "../../FirebaseConfig";
import { motion } from "framer-motion";
import Bgimg from "../assests/HoneyRecipe.png";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode } from "swiper/modules";
import "swiper/css";
import "swiper/css/free-mode";
import { Navigation } from "swiper/modules";

const RecipeCard = ({ recipe, onClick }) => {
  return (
    <motion.div
    whileHover={{ scale: 1.03 }}
    className="w-[280px] bg-white rounded-lg overflow-hidden shadow-md transition-transform duration-300 cursor-pointer"
    onClick={() => onClick(recipe.id)}
  >
    {/* Mini image slider using Swiper */}
    {/* <Swiper
      spaceBetween={5}
      navigation
      modules={[Navigation]}
      className="w-full h-40"
    >
      {recipe.images?.map((img, idx) => (
        <SwiperSlide key={idx}>
          <img
            src={img}
            alt={`slide-${idx}`}
            className="w-full h-40 object-cover"
          />
        </SwiperSlide>
      ))}
    </Swiper> */}
    <img
          src={recipe.thumbnail}
          alt={recipe.name}
          className="w-full h-40 object-cover"
        />

    <div className="p-4 flex flex-col justify-between h-[180px]">
      <div className="text-gray-600 text-sm mb-1">{recipe.date}</div>
      <h2 className="text-md font-bold text-gray-800">{recipe.name}</h2>
      <p className="text-gray-700 text-sm italic flex-grow mt-1">
        {recipe.summary}
      </p>
      <button className="mt-3 px-4 py-2 bg-orange-500 text-white text-sm rounded-full shadow hover:bg-orange-600 transition">
        Read More
      </button>
    </div>
  </motion.div>
);

};

const HoneyRecipesSection = () => {
  const [recipes, setRecipes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchRecipes();
  }, []);

  const fetchRecipes = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "recipes"));
      const recipesArray = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setRecipes(recipesArray);
    } catch (error) {
      console.error("Error fetching recipes:", error);
    }
    setLoading(false);
  };

  const handleClick = (id) => {
    window.location.href = `/recipes?id=${id}`;
  };

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center text-gray-600">
        Loading recipes...
      </div>
    );
  }

  // Split recipes into two arrays for two rows
  const mid = Math.ceil(recipes.length / 2);
  const firstRow = recipes.slice(0, mid);
  const secondRow = recipes.slice(mid);

  return (
    <div
      className="w-full py-16 flex justify-center"
      style={{
        backgroundImage: `url(${Bgimg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="backdrop-blur-lg bg-opacity-50 w-full px-4">
        <h2 className="mb-8 text-center text-xl md:text-2xl font-bold text-gray-900">
          Our Honey-Based Recipes
        </h2>

        {/* 🔹 Laptop View (2 rows with horizontal scroll) */}
        <div className="hidden md:block">
          {[firstRow, secondRow].map((row, rowIndex) => (
            <div
              key={rowIndex}
              className="flex overflow-x-auto gap-4 mb-6 px-2"
            >
              {row.map((recipe) => (
                <div key={recipe.id} className="min-w-[280px] max-w-[300px]">
                  <RecipeCard recipe={recipe} onClick={handleClick} />
                </div>
              ))}
            </div>
          ))}
        </div>

        {/* 🔹 Mobile View: Swiper (1 row horizontal scroll) */}
        <div className="block md:hidden">
          {/* <Swiper
            slidesPerView={"auto"}
            spaceBetween={10}
            freeMode={true}
            modules={[FreeMode]}
            className="px-2"
          >
            {recipes.map((recipe) => (
              <SwiperSlide
                onClick={() => handleClick(recipe.id)}
                key={recipe.id}
                className="min-w-[280px] max-w-[300px]"
              >
                <RecipeCard recipe={recipe} onClick={handleClick} />
              </SwiperSlide>
            ))}
          </Swiper> */}

<Swiper
  slidesPerView={"auto"}
  spaceBetween={10}
  freeMode={true}
  autoplay={{
    delay: 2500,
    disableOnInteraction: false,
  }}
  modules={[FreeMode, Autoplay]}
  className="px-2"
>
  {recipes.map((recipe) => (
    <SwiperSlide
      onClick={() => handleClick(recipe.id)}
      key={recipe.id}
      className="min-w-[280px] max-w-[300px]"
    >
      <div className="h-[420px] bg-white rounded-lg overflow-hidden hover:scale-105 transition-transform duration-300 shadow-lg flex flex-col">
        <img
          src={recipe.thumbnail}
          alt={recipe.name}
          className="w-full h-40 object-cover"
        />
        <div className="p-4 flex flex-col flex-grow">
          <div className="text-gray-600 text-sm mb-1">{recipe.date}</div>
          <h2 className="text-lg font-bold text-gray-800 mb-1">
            {recipe.name}
          </h2>
          <p className="text-gray-700 text-sm italic flex-grow">
            {recipe.summary}
          </p>
          <button className="mt-3 px-4 py-2 bg-orange-500 text-white text-sm rounded-full shadow hover:bg-orange-600 transition">
            Read More
          </button>
        </div>
      </div>
    </SwiperSlide>
  ))}
</Swiper>


        </div>
      </div>
    </div>
  );
};

export default HoneyRecipesSection;
